import React, { Component, PropTypes } from 'react';
import { Modal, Form, Input, Button, Popconfirm, Row, Col, Select, DatePicker, Radio } from 'antd';
import { authorizationDateType } from '../../../config/workflow/authorization';
const FormItem = Form.Item;
const Option = Select.Option;
const RadioGroup = Radio.Group;

class CreateAuthFormInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 0
    }
  }

  changeType = (e) => {
    console.log('changeType', e);
    this.setState({
      type: e.target.value
    });
  }

  componentWillReceiveProps(props) {
    if (this.props.visible !== props.visible && props.visible) {
      this.setState({
        type: props.myAuthorization.authorization && props.myAuthorization.authorization.type || 0
      });
      // this.props.form.setFieldsValue({
      //   type: props.myAuthorization.authorization ? props.myAuthorization.authorization.type : 0
      // });
    }
  }

  render() {
    const { visible, form, myAuthorization, process, onCancel, onOK, onDelete, userList } = this.props;
    console.log('myAuthorization', myAuthorization);
    const { authorization } = myAuthorization;
    const { getFieldDecorator } = form;
    const formItemLayout = {

    }
    const optionUserList = userList.map((u) => {
      const userId = u["uid"].toString();
      return (
        <Option searchValue={u["realName"]} key={u["realName"]}
          value={userId}>{u["realName"]}</Option>
      );
    });
    const footerHandle = () => {
      let btn = [
        (<Button
          key="confirm"
          type="primary"
          size="large"
          onClick={onOK}
        >
          {
            authorization ? '保存' : '提交'
          }
        </Button>)
      ]
      if (authorization) {
        btn.unshift(
          (
            <Popconfirm key="delete" title={"是否确认删除?"} onConfirm={onDelete} okText="确认" cancelText="取消">
              <Button
                size="large"
              >
                删除
          </Button>
            </Popconfirm>
          )
        )
      }
      return btn;
    }
    return (
      <Modal
        visible={visible}
        width={400}
        title={authorization ? '授权更改' : '授权创建'}
        onCancel={onCancel}
        footer={footerHandle()}
      >
        <Form layout="vertical" className="modify-auth">
          <Row className="auth-title">
            <Col span={6}><span style={{ fontSize: 18, fontWeight: 'bold' }}>当</span></Col>
          </Row>
          <Row className="auth-info">
            <Col span={6} className="auth-info-left"><span>流程为:</span></Col>
            <Col span={18} className="auth-info-right"><span>{process && process.name}</span></Col>
          </Row>
          <Row className="auth-info">
            <Col span={6} className="auth-info-left"><span>任务节点为:</span></Col>
            <Col span={18} className="auth-info-right"> <span>{myAuthorization && myAuthorization.name}</span></Col>
          </Row>
          <FormItem label='将此角色授权于' {...formItemLayout}>
            {getFieldDecorator('authorizationUid',
              {
                rules: [{ required: true, message: '请选择角色', max: 400 }],
                initialValue: authorization && authorization.authorizationUid.toString()
              })(
              <Select
                style={{ width: 150 }}
                showSearch
                placeholder="人名"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }}
              >
                {optionUserList}
              </Select>
              )}
          </FormItem>
          <FormItem label='期限' {...formItemLayout}>
            {getFieldDecorator('type',
              {
                rules: [{ required: true, message: '请选择期限类型' }],
                initialValue: authorization && authorization.type
              })(
              <RadioGroup onChange={this.changeType}>
                <Radio key="2" value={authorizationDateType.short}>短期</Radio>
                <Radio key="1" value={authorizationDateType.long}>长期</Radio>
              </RadioGroup>
              )}
          </FormItem>
          {
            this.state.type === authorizationDateType.short ? (
              <FormItem label='起始时间' {...formItemLayout}>
                {getFieldDecorator('sDate',
                  {
                    rules: [{ required: true, message: '请选择起始时间', type: 'object' }],
                  })(
                  <DatePicker />
                  )}
              </FormItem>
            ) : null
          }

          {
            this.state.type === 2 ? (
              <FormItem label='结束时间' {...formItemLayout}>
                {getFieldDecorator('eDate',
                  {
                    rules: [{ required: true, message: '请选择结束时间', type: 'object' }],
                  })(
                  <DatePicker />
                  )}
              </FormItem>
            ) : null
          }
        </Form>
      </Modal>
    )
  }
}

const CreateAuthForm = Form.create({
})(CreateAuthFormInfo);

export default CreateAuthForm;


// WEBPACK FOOTER //
// ./src/components/workflow/authorization/create_auth_form.js